<mat-form-field
	color="accent"
	class="full-width-form"
	[class.disabledAdvancedInput]="isDisabled"
	[class.mat-form-field-invalid]="searchControl.touched && formState.hasError('required')"
>
	<mat-label>
		<ng-content select="[labelSuffix]" />
		{{ label }}
	</mat-label>

	<mat-chip-grid #chipListRef [disabled]="isDisabled" [formControl]="errorCtrl">
		@for (chip of chipList; track chip; let i = $index) {
			<mat-chip-row
				highlighted
				[color]="alternativeColorIds.includes($any(chip.value)?.id) ? 'warn' : 'accent'"
				[removable]="!isDisabled"
				(click)="onItemClicked(chip.value, $event)"
			>
				{{ chip.displayName }}
				<button (click)="onItemRemoved(i)" matChipRemove>
					<mat-icon fontSet="fas" fontIcon="fa-times" style="font-size: 0.7em; margin-top: 6px" inline />
				</button>
			</mat-chip-row>
		}
		<input
			type="text"
			#chipInput
			#autoCompleteTrigger="matAutocompleteTrigger"
			matInput
			[formControl]="searchControl"
			[matChipInputFor]="chipListRef"
			[matAutocomplete]="hasGroupedValues ? autoCompleteGrouped : autoCompleteNormal"
			[matAutocompleteDisabled]="isDisabled"
			[class.hideInput]="!isMultiSelect && formState.value.length > 0"
			[autofocus]="isAutofocusEnabled"
			[placeholder]="placeholder"
			[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
			[matChipInputAddOnBlur]="false"
			(matChipInputTokenEnd)="inputTokenEnd.emit($event)"
			[disabled]="isDisabled"
		/>
	</mat-chip-grid>

	<button (click)="searchClicked()" aria-label="Search" color="accent" mat-icon-button matSuffix>
		<mat-icon fontSet="fad" fontIcon="fa-search" inline />
	</button>

	@if (!!canAddNewItem) {
		<button (click)="emitAddNewItem()" appStopPropagation aria-label="Add item" color="accent" mat-icon-button matSuffix>
			<mat-icon fontIcon="fa-plus" fontSet="fas" />
		</button>
	}

	@if (!!detailButtonConfig) {
		<button
			color="accent"
			matTooltip="{{ detailButtonConfig.tooltip | translate }}"
			matTooltipClass="accent"
			matSuffix
			mat-icon-button
			aria-label="Clear"
			(click)="detailButtonClicked.emit()"
			appStopPropagation
		>
			<ng-content select="[detailButtonContent]" />
		</button>
	}

	<mat-autocomplete
		#autoCompleteNormal="matAutocomplete"
		[displayWith]="displayFn"
		(optionSelected)="autoCompleteOptionSelected($event.option.value)"
	>
		@for (autoCompleteOption of filteredAutoCompleteValues; track autoCompleteOption) {
			<mat-option class="autoCompleteOption" [value]="autoCompleteOption">
				{{ autoCompleteOption.displayName }}
			</mat-option>
		}
	</mat-autocomplete>

	<mat-autocomplete
		#autoCompleteGrouped="matAutocomplete"
		[displayWith]="displayFn"
		(optionSelected)="autoCompleteOptionSelected($event.option.value)"
	>
		@for (group of filteredAutoCompleteGroupedValues; track group) {
			<mat-optgroup [label]="group.groupDisplayName">
				@for (groupValue of group.groupValues; track groupValue) {
					<mat-option [value]="groupValue">
						{{ groupValue.displayName }}
					</mat-option>
				}
			</mat-optgroup>
		}
	</mat-autocomplete>
	<mat-error>
		{{ label }}
		{{ T.SHARED_SIM_ADVANCED_BASIC_INPUT_IS_REQUIRED | translate }}
	</mat-error>
</mat-form-field>
